import React from 'react'
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'

function NavBlock({ prev, next }) {

    const navigate = useNavigate();
    // const location = useLocation();

    const handleNavigation = (nav) => {
        if (nav === "prev") {
            if (prev) {
                window.location.href = prev
            }
            else {
                navigate(-1)
            }
        }
        else {
            if (next) {
                window.location.href = next
            }
            else {
                navigate(-1)
            }
        }
    }

    return (
        <div className='flex items-center justify-between p-2'>
            <FiChevronLeft className='text-3xl text-[#1739bd]' role='button' onClick={() => handleNavigation('prev')} />
            <FiChevronRight className='text-3xl text-[#1739bd]' role='button' onClick={() => handleNavigation('next')} />
        </div>
    )
}

export default NavBlock